import { useCallback } from 'react'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import {
  getEfficiencyScorecardReport,
  type EfficiencyScorecardReportResult,
} from '@services/api/reports/providerPerformance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type EfficiencyScorecardData = EfficiencyScorecardReportResult

export type UseEfficiencyScorecardResult = {
  loading: boolean
  error: string | null
  data: EfficiencyScorecardData | null
  bucketLabel: string
}

export function useEfficiencyScorecard(
  toolbarSelection: Record<string, string>,
): UseEfficiencyScorecardResult {
  const getBucketFromData = useCallback(
    (data: EfficiencyScorecardReportResult): ReportBucketType =>
      data.totalProduction.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getEfficiencyScorecardReport,
    getBucketFromData,
    errorMessage: 'Failed to load efficiency scorecard data',
  })
}
